import { render } from "./PackingOrders.vue?vue&type=template&id=582b9fe8&scoped=true"
import script from "./PackingOrders.vue?vue&type=script&lang=js"
export * from "./PackingOrders.vue?vue&type=script&lang=js"

import "./PackingOrders.vue?vue&type=style&index=0&id=582b9fe8&lang=scss&scoped=true"

import exportComponent from "/Users/fabiankala/Documents/projects/jan-art/jan-art-system/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-582b9fe8"]])

export default __exports__